// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"d489187c","453":"667da9fb","949":"6aba1ed9"}[chunkId] + ".chunk.js";
};